import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';

import TerminalBasePopup from 'src/terminal/popups/TerminalBasePopup';

const TerminalSelfExclusionPopup = ({ id }) => {
  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <TerminalBasePopup
      buttonLabel="terminal_self_exclusion_popup_button"
      className="terminal-self-exclusion-popup"
      icon="warning"
      onButtonClick={handleClose}
      onClose={handleClose}
      text="terminal_self_exclusion_popup_message"
      title="terminal_self_exclusion_popup_title"
    />
  );
};

TerminalSelfExclusionPopup.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default TerminalSelfExclusionPopup;
